import React, { useState, useEffect } from 'react';

/**
 * PC_Fc_04 getFAQData gets imported from api.js file
 */
import { getFAQData } from '../service/api';

import '../components/css/Dashboard-styles.css';

const FAQdata = () => {


    /**
* PC_MTc_02
* The data , index , tabName state variable is created for storing the response data
*/

    const [data, setData] = useState([]);

    const [index, setIndex] = useState(0);

    const [tabName, setTabName] = useState([]);


    /**
* PC_Fc_03
* Use Efffect method is called 
*/

    useEffect(() => {
        fetchApi();
    }, []);


    /**
* PC_Fc_06
* The fetchApi function in the useEffects gets invoked which inturn call the getFAQData() function with respective parameters
*/

    const fetchApi = async () => {
        const resp = await getFAQData();

        if (resp?.data?.ResponseData?.length > 1) {
            setData(resp.data.ResponseData[0]);

            setTabName(resp.data.ResponseData[1]);
        }
    };

    // const questionAnswer = ((headData) => {

    //     return (

    //         headData.map((QAs, j) => {
    //             return (
    //                 <div className="accordion-item mt-3 dashboard-faq-accordion-style">
    //                     <h2 className="accordion-header" id="faq-One">
    //                         <button className="accordion-button font-14 medium-text dashboard-accordion-button-style shadow-none" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${j}`} aria-expanded="true" aria-controls="collapseOne">
    //                             {QAs.questions}
    //                         </button>
    //                     </h2>
    //                     <div id={`collapse${j}`} className="accordion-collapse collapse show " aria-labelledby="faq-One" data-bs-parent="#accordionExample">
    //                         <div className="accordion-body medium-text font-12">
    //                             {QAs.answers}
    //                         </div>
    //                     </div>
    //                 </div>
    //             )

    //         })
    //     )
    // })

    const handleClick = (head) => {
        // 
        // 
        // 

        try {
            return (
                <div className={`tab-pane fade show active`} id="pills-home" role="tabpanel" aria-labelledby={`${head}-faq-tab`}>
                    <div className="accordion p-3" id="accordionExample">
                        {data[index].map((headData, i) => {
                            // setIndex(value)
                            if (i <= 4) {
                                return (
                                    <div className="accordion-item mt-3 dashboard-faq-accordion-style">
                                        <h2 className="accordion-header" id={`faq-One${i}`}>
                                            <button
                                                className={`dashboard-accordion-button font-15 medium-text dashboard-accordion-button-style text-break shadow-none ${i != 0 ? 'collapsed' : null}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${i}`}
                                                aria-expanded={i == 0 ? true : false}
                                                aria-controls={`collapseOne${i}`}
                                            >
                                                {headData.questions}
                                            </button>
                                        </h2>
                                        <div
                                            id={`collapse${i}`}
                                            className={`accordion-collapse collapse  ${i == 0 ? "show" : null}`}
                                            aria-labelledby={`faq-One${i}`}
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body medium-text font-13 faq-ans-color text-break">{headData.answers}</div>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                    </div>
                </div>
            );
        } catch (err) {

        }
    };

    const tabHeading = () => {
        try {
            return tabName.map((heading, i) => {
                return (
                    <>
                        <li className="nav-item">
                            <button
                                onClick={() => {
                                    setIndex(i);
                                    handleClick(heading);
                                }}
                                className={`nav-link rounded-0 ${i == 0 ? 'active' : ''} dashboard-tab-style`}
                                id={`${heading}-faq-tab`}
                                data-bs-toggle="pill"
                                data-bs-target={`#pills-${heading}`}
                                type="button"
                                role="tab"
                                aria-controls={`pill-${heading}`}
                                aria-selected={i == 0 ? true : false}
                            >
                                {heading}
                            </button>
                        </li>
                    </>
                );
            });
        } catch (err) {

        }
    };


    /**
     * PC_Fc_10
     * The response data gets stored in the data and TabNAme variable and mapped to the respective divs
     */

    return (
        <>
            <div className="d-flex justify-content-between dashboard-container-background mt-3 rounded-0">
                <h1 className="tt-bold font-15 pt-3 ps-3">FAQ's</h1>
                <a href="/faq" className="semibold-text font-12 pe-3 text-decoration-none mt-3">
                    View all
                    <span>
                        <img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" />
                    </span>
                </a>
            </div>
            <div className="dashboard-container-background rounded-0">
                <ul className="nav nav-pills ps-3" id="pills-tab" role="tablist">
                    {tabHeading()}
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    {handleClick()}
                </div>
            </div>
        </>
    );
};

export default FAQdata;
